import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const API_URL = 'https://blog.vedmarket.ru/api';

export const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  prepareHeaders: (headers) => {
    const token = '5c2b674d309a90f46e00ba00b52bb3828d6a81f41615a45577ba565b77914102a5cd7b7ca58a391e6abece40f515dd01d89063258fe63ab844176a3cb706b543321417a89856a2ec6b31ff40adf5655461237c267b9495813188243dd33184fa559aac46c5ed53b0115c5ee96b326f664520c6325e4a3e7d66020eaffbe6e706';
    headers.set('authorization', `Bearer ${token}`)
    return headers
  }
})
